import icBall from '@/assets/ic_ball_blue.svg';
import icBars from '@/assets/ic_bars.svg';
import icChevron from '@/assets/ic_chevron.svg';
import icCoins from '@/assets/ic_coins2.svg';
import icCup from '@/assets/ic_cup.svg';
import icUser from '@/assets/ic_user.svg';
import { useIsDesktop } from '@/hooks/useIsDesktop';

const items = {
  RegistrationAndLogin: {
    label: 'Registro e inicio de sesión',
    icon: icUser,
  },
  TeamBuildingAndAwards: {
    label: 'Armado de equipos y premios',
    icon: icBall,
  },
  PinsAndPremiumPack: {
    label: 'Pines y Pack Premium',
    icon: icCoins,
  },
  Scores: {
    label: 'Puntajes',
    icon: icBars,
  },
  SpecialTournaments: {
    label: 'Torneos especiales',
    icon: icCup,
  },
};

export interface SidebarProps {
  selected: keyof typeof items | 'FaqForm' | '';
  onSelect?: (selected: SidebarProps['selected']) => void;
}

export const SideBar = ({ selected, onSelect }: SidebarProps) => {
  const { isMobile } = useIsDesktop();

  return (
    <ul
      className={`pt-2 border-r border-gdt-gray-6 min-h-full md-shadow-[-9px_0px_15px_0px_rgba(0,_0,_0,_0.1)] bg-white`}
    >
      {Object.entries(items).map((item) => (
        <li
          key={item[0]}
          className="flex pt-5 mx-6 md:mx-0 md:pl-20 md:pr-12 border-b border-gdt-gray-6 pb-5 justify-between cursor-pointer"
          onClick={() => onSelect?.(item[0] as keyof typeof items)}
        >
          <div className="flex gap-x-3 items-center content-center">
            <img
              alt="Gran DT - logo calendario"
              className="w-5 h-5"
              src={item[1].icon}
            />
            <span
              className={`text-lg   ${
                selected === item[0] ? 'text-gdt-blue font-bold' : 'font-medium'
              }`}
            >
              {item[1].label}
            </span>
          </div>
          <button
            className="w-7 h-7 rounded-lg bg-gdt-blue-light2 flex justify-center items-center"
            onClick={() => onSelect?.(item[0] as keyof typeof items)}
            onKeyUp={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSelect?.(item[0] as keyof typeof items);
              }
            }}
          >
            <img
              alt="Gran DT - flecha derecha"
              className="w-3 h-3"
              src={icChevron}
            />
          </button>
        </li>
      ))}
      {isMobile && (
        <li>
          <h1 className="font-medium text-[14px] my-6 ml-6">
            Si no encontraste la respuesta a tu consulta, podés{' '}
            <button
              className="inline-flex items-center text-blue-500 hover:text-blue-700 underline focus:outline-none"
              type="button"
              onClick={() => onSelect?.('FaqForm')}
            >
              enviarnos un mensaje.
            </button>
          </h1>
        </li>
      )}
    </ul>
  );
};
